<template>
  <v-row no-gutters>
    <v-col cols="12">
      <nmt-sidebar-profile-stat v-for="stat in statistics" :key="stat.name" v-bind="stat" class="py-1">
      </nmt-sidebar-profile-stat>
    </v-col>
  </v-row>
</template>

<script>
import NmtSidebarProfileStat from '@/components/NmtSidebarProfileStat';

export default {
  name: 'NmtSidebarProfileStats',
  components: {
    NmtSidebarProfileStat,
  },
  props: {
    statistics: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped></style>
